<div class="fp-body">

    <!-- Header -->
    <div class="fp-header">
        <div>
            <h2 class="fp-title">Full Programme</h2>
            <p class="fp-subtitle" *ngIf="patientLabel">{{ patientLabel }}</p>
        </div>
        <button class="fp-close" type="button" (click)="modal.dismiss()" aria-label="Close">&times;</button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="fp-loading">
        <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
    </div>

    <!-- Empty -->
    <div *ngIf="!loading && weeks.length === 0" class="alert alert-warning mb-0">
        No modules found for this programme.
    </div>

    <!-- Week sections -->
    <ng-container *ngIf="!loading && weeks.length > 0">
        <div class="fp-week" *ngFor="let week of weeks">

            <button class="fp-week-header" type="button" (click)="toggleWeek(week)">
                <span class="fp-week-title">Week {{ week.weekNumber }}</span>
                <span class="fp-week-count">{{ week.modules.length }} module{{ week.modules.length !== 1 ? 's' : '' }}</span>
                <i class="bi" [class.bi-chevron-up]="week.expanded" [class.bi-chevron-down]="!week.expanded"></i>
            </button>

            <div class="fp-modules-grid" *ngIf="week.expanded">
                <div class="fp-module" *ngFor="let entry of week.modules">

                    <!-- Thumbnail -->
                    <img
                        *ngIf="entry.module.thumbnailUrl"
                        class="fp-module__thumb"
                        [src]="entry.module.thumbnailUrl"
                        [alt]="entry.module.displayTitlePortal || entry.module.displayTitle">
                    <div class="fp-module__thumb fp-module__thumb--placeholder" *ngIf="!entry.module.thumbnailUrl">
                        <i class="bi bi-book"></i>
                    </div>

                    <!-- Body -->
                    <div class="fp-module__body">
                        <span class="fp-module__title">{{ entry.module.displayTitlePortal || entry.module.displayTitle }}</span>
                        <p class="fp-module__desc" *ngIf="entry.module.shortDescription">{{ entry.module.shortDescription }}</p>
                        <div class="fp-progress">
                            <div class="fp-progress__bar">
                                <div class="fp-progress__fill" [style.width.%]="progressPct(entry.progressValue)"></div>
                            </div>
                            <span class="fp-progress__pct">{{ progressPct(entry.progressValue) }}%</span>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </ng-container>

</div>
